import { TextFieldInput } from '../../../../inputs/text-field-input'
import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { ReportDefinitionFilter } from '../../../../generated/graphql'
import { ReportForm } from '../../report-form'

type Props = {
  searchTextFilterKey: keyof Pick<
    ReportDefinitionFilter,
    'orderSearchText' | 'warehouseSearchText'
  >
}

export const SearchTextInput = (props: Props) => {
  const { t } = useTranslation('reports')
  const { control } = useFormContext<ReportForm>()

  return (
    <TextFieldInput
      control={control}
      label={t('create_dialog.search_text')}
      name={`reportdefinition.filters.${props.searchTextFilterKey}`}
    />
  )
}
